import { ZipCodeBox } from '@apply/components';
import { useBorrowerEntityZipCode } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface BorrowerZipCodeProps {
    readOnly?: boolean;
    isReview?: boolean;
}

export const BorrowerZipCode: React.FC<BorrowerZipCodeProps> = ({ readOnly = false, isReview = false }) => {
    const label = 'Zip Code';
    const [zipCode, set_zipCode] = useBorrowerEntityZipCode();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={zipCode}
                />
            ) : (
                <ZipCodeBox
                    value={zipCode}
                    onChange={(value) => set_zipCode(value)}
                    label={label}
                    required={true}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
